import { Col, Divider, Modal, Row, Slider, Space, Tag, InputNumber } from "antd";
import { Form, Formik } from "formik";
import { useEffect, useMemo, useState } from "react";

import { Button } from "components/elements";
import { DatePicker, Input, RadioGroup, Select } from "components/form";

import { useTranslation } from "react-i18next";
import schema, {
  initialValues as INITIAL_VALUES,
} from "../schemas/accountCategorySchema";
import styles from "../styles/AccountCategoryFilter.module.css";
import useStatusFlagOption from "components/elements/Select/StatusDropdown";

const AccountCategoryFilter = ({

  durationOptions = [],

  onSubmit = () => { },
  onCancel = () => { },
}) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const { modifiedStatus = [] } = useStatusFlagOption()
  console.log("man ", modifiedStatus);
  // const modifiedStatus = useMemo(() => {
  //   return statusOptions.map((opt) => ({
  //     ...opt,
  //     label: opt.label,
  //     value: opt.value
  //   }))

  // })



  return (
    <Formik
      initialValues={INITIAL_VALUES}
      onSubmit={(values) => {
        onSubmit({
          ...values,
          // statusFlag: '',

        });
      }}

    // validationSchema={schema}
    >
      {({ resetForm, values = {}, setFieldValue = () => { }, setTouched = () => { } }) => {
        return (
          <Form>
            <Row gutter={[24, 16]} className={styles.filter} >
              <Col span={12}>
                <Input
                  name="commonTypeName"
                  label={t("account_category_list.label.Account_Category_name")}
                  placeholder={t("account_category_list.label.Account_Category_name")}
                  size="large"
                />
              </Col>

              <Col span={12}>
                <Select
                  name="statusFlag"
                  label={t('year_accumulate_list.label.status')}
                  placeholder={t('year_accumulate_list.label.status')}
                  size="large"
                  options={modifiedStatus}
                />
              </Col>

            </Row>
            <Row justify="end">
              <Space size={24} className={styles.filterbtn}>
                <Button type="default" onClick={resetForm}>
                  {t('payroll.reset')}
                </Button>
                <Button type="primary" htmlType="submit">
                  {t("creatTamplete.Search").toUpperCase()}
                </Button>
              </Space>
            </Row>
          </Form>
        );
      }}
    </Formik>
  );
};

export default AccountCategoryFilter;
